import { Sparkles, SquarePen, Zap } from 'lucide-react';
import { Tooltip } from '@wundo/ui';
import type { Skill } from '@/lib/skills.ts';

/*
 * Three booleans, three icons. A lit icon means the skill has that switch on;
 * a faint one means it is off but still worth showing, so the column reads as
 * a row of the same three answers rather than a ragged list of chips.
 */
const FLAGS = [
  {
    key: 'triggerable',
    Icon: Zap,
    on: 'Triggerable',
    off: 'Not triggerable',
    tone: 'text-success',
  },
  {
    key: 'recommendable',
    Icon: Sparkles,
    on: 'Recommendable',
    off: 'Not recommendable',
    tone: 'text-ink',
  },
  {
    key: 'notes_enabled',
    Icon: SquarePen,
    on: 'Notes enabled',
    off: 'Notes disabled',
    tone: 'text-ink-secondary',
  },
] as const;

export function SkillFlags({ skill }: { skill: Skill }) {
  return (
    <span className='flex items-center gap-1'>
      {FLAGS.map(({ key, Icon, on, off, tone }) => {
        const enabled = skill[key];
        const label = enabled ? on : off;

        return (
          <Tooltip key={key} content={label}>
            <span role='img' aria-label={label} className='inline-flex'>
              <Icon className={enabled ? `size-4 ${tone}` : 'size-4 text-ink-muted'} />
            </span>
          </Tooltip>
        );
      })}
    </span>
  );
}
